// extracted by mini-css-extract-plugin
export var root = "_zc-0";
export var scroll = "_zc-1";
export var thumb = "_zc-3";
export var track = "_zc-2";